<template>
  <div>
    <el-dialog
      :title="title"
      :visible="statusMixShow"
      width="1000px"
      @close="close"
      @open="openInit"
      append-to-body
    >
      <div class="localsList mix-wrap-status">
        <p class="batch-p">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-switch
            v-model="comVal"
            active-text="开启"
            inactive-text="关闭"
            inactive-value="PAUSED"
            active-value="ACTIVE"
            :disabled="!checkedDatas.length"
            @change="(val) => batchChange('status', val)"
          >
          </el-switch>
        </p>
        <el-checkbox-group
          v-model="checkedDatas"
          @change="(val)=>handleCheckedDatasChange('status',statusMsgList,val)"
        >
          <el-checkbox v-for="item in dataList" :label="item.id" :key="item.id">
            <span class="mixName">{{ item.name }}</span>
            <el-switch
              v-model="item.status"
              active-text="开启"
              inactive-text="关闭"
              inactive-value="PAUSED"
              active-value="ACTIVE"
            >
            </el-switch>
          </el-checkbox>
        </el-checkbox-group>
        <!-- <el-row :gutter="10" v-for="(item) in dataList" :key="item.id">
                    <el-col :span="16" style="line-height:40px">
                        <span class="mixName">{{item.name}}</span>
                    </el-col>
                    <el-col :span="8">
                         <el-switch v-model="item.status" active-text="开启" inactive-text="关闭" inactive-value="PAUSED" active-value="ACTIVE"> </el-switch>
                    </el-col>
                </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixBatchOperate from "@/views/adManagement/assets/js/mixBatchOperate";
export default {
  mixins: [mixBatchOperate],
  props: {
    statusMixShow: {
      type: Boolean,
      default: () => false,
    },
    statusMsgList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => "链接",
    },
  },
  data() {
    return {
      dataList: JSON.parse(JSON.stringify(this.statusMsgList)),
    };
  },
  methods: {
    close() {
      this.backToInit(this.statusMsgList);
      this.$emit("update:statusMixShow", false);
    },
    openInit() {},
    sure() {
      this.$emit("setMixMsg", "status", this.dataList);
      this.close();
    },
  },
  watch: {
    statusMsgList: {
      handler() {
        this.dataList = JSON.parse(JSON.stringify(this.statusMsgList));
      },
    },
    deep: true,
  },
};
</script>
<style lang="scss" scoped>
.localsList {
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: auto;
  .el-row {
    margin-bottom: 10px;
  }
}
.el-switch {
  height: 40px;
}
</style>
<style lang="scss">
.mix-wrap-status {
  .batch-p {
    display: flex;
    align-items: center;
    .el-switch {
      margin-left: 10px;
    }
  }
  .el-checkbox-group {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .el-checkbox {
      width: 95%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }
    .el-checkbox__label {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
